module.exports = __webpack_public_path__ + "assets/agregar.c3104b91653e63e056eb0d4975c36f15.svg";


//////////////////
// WEBPACK FOOTER
// ./img/agregar.svg
// module id = 935
// module chunks = 0